export const ACTION_GET_TIPS = "ACTION_GET_TIPS";
export const ACTION_POST_CREATE_TIPS = "ACTION_POST_CREATE_TIPS";
export const ACTION_PUT_UPDATE_TIPS = "ACTION_PUT_UPDATE_TIPS";
export const ACTION_DELETE_TIPS = "ACTION_DELETE_TIPS";
